import { defaultReducers, defaultInitialState } from "../../../../../redux/_common";
import { createSlice } from "@reduxjs/toolkit";


const initialState = {...defaultInitialState};
const reducers = {...defaultReducers};

export const countryWithCodeSlice = createSlice({
  name: "countryWithCode",
  initialState,
  reducers,
});

